<template>
  <div>
    <div class="width-max">
      <p class="title is-4 is-spaced has-text-weight-normal label-Left is-align-center is-flex-medium">Dashboard
      </p>
    </div>
    <b-tabs v-model="activeTab" size="is-large">
      <b-tab-item label="Admin Signup Link">
        <div class="is-justify-center is-align-start is-flex-medium is-flex-row width-max is-margin-bottom-2">
          <div class="width-max">
            <p class="title is-4 is-spaced has-text-weight-normal label-Left is-align-center is-flex-medium">
              <a @click="addAdminSigupLink" class="button is-primary is-margin-left-sm">Add Link
                <i class="fas fa-plus is-margin-left-sm"></i>
              </a>
            </p>
          </div>
        </div>
        <div v-for="(item,index) in adminLink" :key="index" class="field is-horizontal">
          <div class="field-label is-normal has-text-left">
            <label class="label has-text-primary-green has-text-weight-normal">
              <i class="fas fa-link"></i> Admin Sign up link
            </label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                class="input has-border-primary"
                type="text"
                v-model="item.link"
                :id="'admin-link'+index"
                readonly
              >
            </div>
          </div>
          <div class="field-body is-padding-sm-x">
            <div class="field">
              <button
                class="button has-bg-primary has-text-white"
                @click="copyAdminLink(index)"
              >Copy Link</button>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Exclusive Board license">
        <div class="is-justify-center is-align-start is-flex-medium is-flex-row width-max is-margin-bottom-2" >
          <div class="width-max">
            <p class="title is-4 is-spaced has-text-weight-normal label-Left is-align-center is-flex-medium">

            </p>
          </div>
        </div>
        <div class=" m-h-auto">
          <div class="column is-6 mg-x-auto">
            <b-field label="Ministry" class="label-Left">
              <b-select placeholder="" expanded v-model="ministryName">
              <option
                class="th has-text-left"
                v-for="option in ministryData"
                :value="option"
                :key="option._id">
                {{ option.name | snippetMid }}
              </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6 mg-x-auto">
             <b-field label="Main department" class="label-Left">
              <b-select placeholder="" expanded v-model="underName">
              <option
                class="th has-text-left"
                v-for="option in filterDepartmentName"
                :value="option"
                :key="option._id">
                {{ option.name }}
              </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="is-justify-center is-align-center is-flex">
          <div class="steps-action boxBtnNext confirm-margin-bottom">
            <a @click="generateLicense()" class="button is-paddingless is-marginless is-light mg-y-25 is-btn-link has-text-centered">Generate</a>
          </div>
        </div>
        <div class="columns m-h-auto " v-if="getLicense">
          <div class="column is-flex is-align-end is-6 mg-x-auto">
            <b-field
              label="Licens"
              class="label-Left"
            >
              <b-input
                placeholder=""
                type="text"
                class="mg-r-5"
                id="input-license"
                v-model="getLicense"
              ></b-input>
            </b-field>
            <button
                class="button has-bg-primary has-text-white"
                @click="copyLicense()"
              >Copy Link</button>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  
  </div>
</template>

<style>
#signupLink .field-label {
  flex-grow: 1.9;
}
#titleLink{
  min-width:210px;
  margin-right: 0!important;
}
#inputCompanyLink{
  min-width: 300px;
}
#titleStaffLink{
  min-width:210px;
}
#inputCompanyLink{
  min-width: 300px;
}
</style>

<script>
import { HTTP } from '../axios.js';

export default {
  computed: {
    getRule() {
      return this.$store.state.rule;
    },
    batch() {
      return this.$store.state.batch;
    },
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    filterOrganizeName() {
      return this.dataOrganization.filter(option => {
        return (
          option.underId
            .toString()
            .toLowerCase()
            .indexOf(this.underName._id) >= 0
        );
      });
    },
    filterDepartmentName() {
      return this.dataDepartment
    },
  },

  data() {
    return {
      ministryName:'',
      sciencePark:'',
      underName:'',
      adminLink: [],
      activeTab:1,
      isLoadingPage: true,
      license:[],
      ministryData:[],
      dataOrganization:[],
      dataDepartment:[],
      getLicense:''
    };
  },
  async created() {
    this.getMinitry()
    this.getDepartment();
    this.getOrganization();
    this.getLinkSigupAdmin();
    // this.getLicense()
  },
  mounted() {
    this.isLoadingPage = false;
  },
  methods: {
    generateLicense(){
      this.isLoadingPage = true;
      let data = {
        underId:this.underName._id,
        ministryId:this.ministryName._id
      }
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("/api/new/license",data).then(res => {
        if(res.data.success){
          this.getLicense = res.data.obj
        //  console.log('/api/new/license',res)
          this.isLoadingPage = false;
        }  
      }).catch((e) => {
        console.log('/api/new/license/error', e);
        alert('เครือขายไม่เสถียร กรุณาลองใหม่');
      });;
    },
    getMinitry(){
      HTTP.post("/api/get/ministry").then(res => {
        this.ministryData = res.data.obj;
      });
    },
    getOrganization() {
      HTTP.post("/get/all/science/park").then(res => {
        this.dataOrganization = res.data.obj;
      });
    },
    getDepartment() {
      HTTP.post("api/get/all/under").then(res => {
        this.dataDepartment = res.data.obj;
      });
    },
    copyLicense(index) {
      const copyText = document.getElementById(`input-license`);
      copyText.select();
      document.execCommand('copy');
      this.$toast.open({ message: 'Copied to clipboard!',type: 'is-dark'})
    },
    copyAdminLink(index) {
      const copyText = document.getElementById(`admin-link${index}`);
      copyText.select();
      document.execCommand('copy');
      this.$toast.open({ message: 'Copied to clipboard!',type: 'is-dark'})
    },
    // getLicense(){
    //   HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
    //   HTTP.post('api/get/all/token/exclusive')
    //     .then((res) => {
    //         this.license=res.data.obj
    //     }).catch((e) => {
    //       console.log('/api/get/all/token/exclusive', e);
    //       alert('เครือขายไม่เสถียร กรุณาลองใหม่');
    //     });
    // },
    getLinkSigupAdmin() {
      this.adminLink = []
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get('api/user/get/all/token/register')
        .then((res) => {
         // console.log('api/user/get/all/token/register',res)
         if(res.data.links.length > 0){
          this.adminLink = res.data.links
          this.adminLink.map(data=>{
            data.link = `${process.env.VUE_APP_BASE_URL}${data.link}`
          })
         }
            
     
        })
        .catch((e) => {
          console.log('api/user/get/all/token/register/error', e);
          alert('เครือขายไม่เสถียร กรุณาลองใหม่');
        });
    },
    addLicense(){
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`api/create/token/exclusive`)
        .then((res) => {
          this.license.push({token:res.data.obj})
        })
        .catch((e) => {
          console.log('api/create/token/exclusive', e);
          alert('เครือขายไม่เสถียร กรุณาลองใหม่');
        });
    },
    addAdminSigupLink() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`api/user/generate/token/register/${this.user._id}`)
        .then((res) => {
        //  console.log("api/user/generate/token/register/{id}", res);
          this.getLinkSigupAdmin();
        })
        .catch((e) => {
          console.log('api/user/generate/token/register/error', e);
          alert('เครือขายไม่เสถียร กรุณาลองใหม่');
        });
    },
  },
};
</script>
